<script>
import baseInput from '../mixins/baseInput'
import ButtonLoader from '@/components/atoms/ButtonLoader'
import { parsePhoneNumber, format } from 'libphonenumber-js'
export default {
    name: 'InputPhone',

    components: {
        ButtonLoader,
    },

    mixins: [baseInput],

    inheritAttrs: false,

    props: {
        type: {
            type: String,
            default: 'text',
        },
        buttonIcon: {
            type: String,
            default: undefined,
        },
        buttonText: {
            type: String,
            default: undefined,
        },
        infoText: {
            type: String,
            default: undefined,
        },
        buttonDisabled: Boolean,
        buttonLoading: Boolean,
    },
    data() {
        return {
            asYouType: null,
        }
    },

    computed: {
        phoneFormat() {
            return this.$store.getters['site/phoneFormat']
        },
        clickable() {
            return Boolean(this.$listeners.click)
        },
    },
    methods: {
        onClick() {
            if (this.clickable) this.$emit('click')
            if (this.clickable) this.$emit('click')
        },
        onInput(evt) {
            if (!this.disabled && !this.readonly) {
                let formattedValue
                try {
                    let parsedValue = parsePhoneNumber(evt.target.value, this.phoneFormat)
                    if (parsedValue.isValid()) {
                        formattedValue = format(
                            parsedValue.number,
                            this.phoneFormat,
                            'International'
                        )
                    }
                    // eslint-disable-next-line no-empty
                } catch {}
                if (formattedValue && formattedValue !== evt.target.value && this.$refs.inputEl) {
                    this.$refs.inputEl.value = formattedValue
                }
                this.$emit('input', formattedValue ? formattedValue : evt.target.value, this)
            }
        },
    },

    render(h) {
        const input = h('input', {
            class: [
                'form-control',
                {
                    'form-control-xs': this.xs,
                    'form-control-sm': this.sm,
                    'form-control-lg': this.lg,
                    'is-invalid': this.hasError,
                    'is-info': this.warning && !this.hasError,
                },
            ],
            domProps: {
                value: this.value,
            },
            on: {
                input: this.onInput,
                blur: this.onBlur,
                focus: this.onFocus,
                change: this.onChange,
            },
            attrs: {
                type: 'text',
                id: this.uid,
                required: this.required,
                ariaLabel: this.placeholder,
                placeholder: this.placeholder,
                disabled: this.disabled,
                readonly: this.readonly,
                autocomplete: this.autocomplete,
            },
            ref: 'inputEl',
        })
        const appendButton =
            this.buttonIcon || this.buttonText
                ? h('div', { class: 'input-group-append' }, [
                      h(
                          'button-loader',
                          {
                              class: [
                                  'btn',
                                  'btn-primary',
                                  { 'btn-xs': this.xs, 'btn-sm': this.sm, 'btn-lg': this.lg },
                              ],
                              props: {
                                  loading: this.buttonLoading,
                                  disabled:
                                      this.hasError ||
                                      this.disabled ||
                                      this.readonly ||
                                      this.buttonDisabled ||
                                      this.buttonLoading,
                              },
                              on: {
                                  click: () => this.$emit('click'),
                              },
                          },
                          [
                              this.buttonIcon
                                  ? h('icon', {
                                        class: { 'mr-2': this.buttonText },
                                        props: { icon: this.buttonIcon },
                                    })
                                  : undefined,
                              this.buttonText,
                          ]
                      ),
                  ])
                : undefined
        const label = h(
            'label',
            {
                attrs: {
                    for: this._uid,
                    dataDisabled: this.disabled,
                },
            },
            [
                this.$slots.default,
                this.required ? h('sup', {}, ['*']) : null,
                this.helper ? h('span', { class: 'input-helper' }, [this.helper]) : null,
            ]
        )
        const feedback = h(
            'div',
            {
                class: 'invalid-feedback',
            },
            [this.hintText]
        )
        const info = h(
            'div',
            {
                class: 'text-99',
            },
            [this.infoText]
        )

        return h(
            'div',
            {
                class: 'form-group',
            },
            [
                this.hasDefaultSlot || this.helper ? label : null,
                this.buttonIcon || this.buttonText
                    ? h('div', { class: 'input-group' }, [input, appendButton])
                    : input,
                this.hasError || this.warning || this.infoText
                    ? this.hasError || this.warning
                        ? feedback
                        : info
                    : null,
            ]
        )
    },
}
</script>
